/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../Common/DataTableFilter";
import { WebSocketContext } from "../../App";
import { ClearFormSetFutios } from "../../redux/actions/adminActions";
import wsSend_request from "../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../Common/CommonTable";
import { ADD_MARKETING_CAMPAIGNS_URL, EDIT_MARKETING_CAMPAIGNS_URL } from "../Shared/constant";
import { useNavigate } from "react-router-dom";

const MarketingCampaigns = () => {
    const Dispatch = useDispatch();
    const Navigate = useNavigate();
    const { MarketCampaignsListing, device_id, selfInfo } = useSelector((state) => state.adminReducers);
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const { websocket } = useContext(WebSocketContext);
    const PermissionsAccess = selfInfo?.user?.permissions_access;
    
    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };
    
    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.DealerApp[7]?.Edit || PermissionsAccess?.DealerApp[7]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "list_marketing_campaign",
                "request" : { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "order_by": "-updated_at",
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userType, currentPage, userLimit ]);

    // create applications
    const cmnFnct = () => {
        Navigate(ADD_MARKETING_CAMPAIGNS_URL);
    };

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'card_title', label: 'Card Title', type: "label", sort: "", isCollapsable: false },
        { key: 'card_description', label: 'Card Description', type: "label", sort: "", isCollapsable: false },
        { key: 'start_date', label: 'Start Date', type: "date", sort: "", isCollapsable: false },
        { key: 'end_date', label: 'End Date', type: "date", sort: "", isCollapsable: false },
        { key: 'status', label: 'Status', type: "status_active", sort: "", isCollapsable: false },
        { key: 'categories', label: 'categories', type: "categories_tables", sort: "", isCollapsable: true },
    ];

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={"MarketCampaigns"}
            searchType={""}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[7]?.Edit)}
            ButtonSet={{
                buttontitle: "Create Marketing Campaign",
                function: cmnFnct
            }}
            searchdisable={false}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{
                height: parseInt(MarketCampaignsListing?.pagination?.total_records) === MarketCampaignsListing?.list?.length ? "calc(100vh - 140px)" : parseInt(MarketCampaignsListing?.pagination?.total_records) > 10 ? "calc(100vh - 175px)" : "calc(100vh - 140px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={true}
            tabName={""} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={MarketCampaignsListing} // CATEGORY LIST
            Pagination={MarketCampaignsListing?.pagination} // CURRENT TAB PAGINATION
            EditAccess={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[7]?.Edit)} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[7]?.Edit,
                label: "edit_marketing_campaign",
                naviagte: `${EDIT_MARKETING_CAMPAIGNS_URL}`,
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>);
};

export default MarketingCampaigns;